export default function ({ size=1, inverse=false, className, children }) {
    return (
        <p className={`${!inverse ? 'text-primary-900' : 'text-white'} font-bold ${size==1 ? 'text-3xl' : 'text-2xl'} ${className}`}>
            { children }
        </p>
    )
}